import QualityRequirementsPolicies from './components/qualityRequirementsPolicies';

function QualityRequirementsPoliciesPage() {
    return <QualityRequirementsPolicies />;
}

export default QualityRequirementsPoliciesPage;
